import { render, staticRenderFns } from "./RecruiterQaEntityChips.vue?vue&type=template&id=54cd4666&scoped=true"
import script from "./RecruiterQaEntityChips.vue?vue&type=script&lang=js"
export * from "./RecruiterQaEntityChips.vue?vue&type=script&lang=js"
import style0 from "./RecruiterQaEntityChips.vue?vue&type=style&index=0&id=54cd4666&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cd4666",
  null
  
)

export default component.exports